import React from 'react';
import './VideoSpcPremium.css';

const VideoSpcPremium = () => {
  return (
    <section className="video-section pb-lg-22 pt-lg-22">
      <div className="container">
        <div className="row justify-content-center mb-5 mb-lg-8">
          <div className="col-lg-8 text-center">
            <div className="mb-1-9 mb-lg-2-5 title-style5">
              <span className="sub-title">Conoce el producto</span>
              <h2 className="display-5 lh-1 font-weight-800 mb-0">
                Piso SPC Luxury en Acción
              </h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="video-container wow fadeInUp" data-wow-delay="200ms">
              <iframe 
                width="100%" 
                height="600" 
                src="https://www.youtube.com/embed/IYR4y_Fora8?si=TcSnZHDCE3hgGW0a" 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen
                className="video-iframe"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSpcPremium;
